export default {
  menus: {
    // 公共
    index: '首頁',
    // 一级
    workplace: '工作臺',
    content: '內容管理',
    column: '欄目管理',
    config: '配置',
    statistics: '網站統計',
    interact: '互動',
    social: '社交媒體',
    vip: '會員',
    system: '系統',
    siteMessage: '站內信',
    // 二级
    // 系统
    organize: '組織管理',
    role: '角色管理',
    user: '用戶管理',
    model: '模型管理',
    resource: '資源庫',
    safe: '帳戶安全設置',
    security: '密級管理',
    storage: '存儲管理',
    thirdParty: '第三方登錄設置',
    sms: '短信服務設置',
    email: '郵件服務設置',
    weixin: '微信開放平臺設置',
    firewall: '防火墻設置',
    backup: '數據備份',
    log: '日誌管理',
    // 三级
    // 系统
    organizeIndex: '組織管理',
    organizeDetail: '組織管理-詳情',
    organizeMember: '組織管理-成員管理',
    organizePermission: '組織管理-權限分配',
    roleIndex: '角色管理',
    roleEdit: '角色管理-修改',
    roleMember: '角色管理-成员管理',
    rolePermission: '角色管理-權限分配',
    userIndex: '用戶管理',
    userPermission: '用戶管理-權限分配',
    modelIndex: '模型管理',
    resourceIndex: '資源庫',
    systemSetting: '系統設置',
    systemSettingIndex: '系統設置',
    safeIndex: '帳戶安全設置',
    securityUser: '人員密級',
    securityUserIndex: '人員密級',
    securityUserDetail: '人員密級詳情',
    securityContent: '內容密級',
    securityContentIndex: '內容密級',
    securityContentDetail: '內容密級詳情',
    securityAccessory: '附件密級',
    securityAccessoryIndex: '附件密級',
    securityAccessoryDetail: '附件密級詳情',
    storageIndex: '存儲管理',
    thirdPartyIndex: '第三方登錄設置',
    smsIndex: '短信服務設置',
    emailIndex: '郵件服務設置',
    weixinIndex: '微信開放平臺設置',
    firewallIndex: '防火墻設置',
    backupIndex: '數據備份',
    logIndex: '日誌管理',
    menus: '菜單管理',
    menusMenus: '菜單管理',
    menusMenusIndex: '菜單管理列表',
    menusMenusDetail: '菜單管理詳情',
    menusMenusCreate: '新增菜單',
    menusApis: '接口管理',
    menusApisIndex: '接口管理列表',
    menusApisDetail: '接口详情',
    storageFtpIndex: 'FTP',
    storageCloudIndex: 'OSS雲存儲'
  }
}
